import { useState, useEffect } from "react";

function useOrientation() {
  const [isPortraitOrSmall, setIsPortraitOrSmall] = useState(
    window.matchMedia("(orientation: portrait)").matches || window.innerWidth < 680
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");
    const updateState = () => {
      setIsPortraitOrSmall(
        mediaQuery.matches || window.innerWidth < 680
      );
    };

    // Attach listeners for both media query and window resize
    mediaQuery.addEventListener("change", updateState);
    window.addEventListener("resize", updateState);

    // Initial check
    updateState();

    return () => {
      mediaQuery.removeEventListener("change", updateState);
      window.removeEventListener("resize", updateState);
    };
  }, []);

  return isPortraitOrSmall;
}

export default useOrientation;
